export const getActionPlans = async ({ params }) => {
  try {
    const {
      data: {
        data: { result },
      },
    } = await fetchGlobalApi({
      method: "GET",
      endpoint: "action-plans",
      params,
    })

    return result.action_plans
  } catch (error) {
    return []
  }
}

export const getComments = async ({ params }) => {
  try {
    const {
      data: {
        data: { result },
      },
    } = await fetchGlobalApi({
      method: "GET",
      endpoint: "comments",
      params,
    })

    return result.comments
  } catch (error) {
    return []
  }
}

export const createComment = async ({ data }) => {
  try {
    await fetchGlobalApi({
      method: "POST",
      endpoint: "comments",
      data,
    })

    return true
  } catch (error) {
    return false
  }
}

export const deleteComment = async ({ id_comment }) => {
  try {
    await fetchGlobalApi({
      method: "DELETE",
      endpoint: `comments/${id_comment}`,
    })
  } catch (error) {}
}

export const editCommentFunc = async ({ data, id_comment }) => {
  try {
    await fetchGlobalApi({
      method: "POST",
      endpoint: `comments/${id_comment}`,
      data: {
        _method: "PUT",
        ...data,
      },
    })
  } catch (error) {}
}

export const markReadComment = async ({ data }) => {
  try {
    const response = await fetchGlobalApi({
      method: "POST",
      endpoint: "comments/read",
      data,
    })
  } catch (error) {
    return []
  }
}

export const markReadActionPlan = async ({ data }) => {
  try {
    const response = await fetchGlobalApi({
      method: "POST",
      endpoint: "action-plans/read",
      data,
    })
  } catch (error) {
    return []
  }
}
